'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _languageHandler = require('../../../languageHandler');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _dispatcher = require('../../../dispatcher');

var _dispatcher2 = _interopRequireDefault(_dispatcher);

var _model = require('../../../editor/model');

var _model2 = _interopRequireDefault(_model);

var _caret = require('../../../editor/caret');

var _dom = require('../../../editor/dom');

var _serialize = require('../../../editor/serialize');

var _deserialize = require('../../../editor/deserialize');

var _Autocomplete = require('../rooms/Autocomplete');

var _Autocomplete2 = _interopRequireDefault(_Autocomplete);

var _parts = require('../../../editor/parts');

var _render = require('../../../editor/render');

var _matrixJsSdk = require('matrix-js-sdk');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MessageEditor = function (_React$Component) {
    (0, _inherits3.default)(MessageEditor, _React$Component);

    function MessageEditor(props, context) {
        (0, _classCallCheck3.default)(this, MessageEditor);

        var _this = (0, _possibleConstructorReturn3.default)(this, (MessageEditor.__proto__ || (0, _getPrototypeOf2.default)(MessageEditor)).call(this, props, context));

        _this._updateEditorState = function (caret) {
            (0, _render.renderModel)(_this._editorRef, _this.model);
            if (caret) {
                try {
                    (0, _caret.setCaretPosition)(_this._editorRef, _this.model, caret);
                } catch (err) {
                    console.error(err);
                }
            }
            _this.setState({ autoComplete: _this.model.autoComplete });
        };

        _this._onInput = function (event) {
            var sel = document.getSelection();

            var _getCaretOffsetAndTex = (0, _dom.getCaretOffsetAndText)(_this._editorRef, sel),
                caret = _getCaretOffsetAndTex.caret,
                text = _getCaretOffsetAndTex.text;

            _this.model.update(text, event.inputType, caret);
        };

        _this._onKeyDown = function (event) {
            // insert newline on Shift+Enter
            if (event.shiftKey && event.key === "Enter") {
                event.preventDefault(); // just in case the browser does support this
                document.execCommand("insertHTML", undefined, "\n");
                return;
            }
            // autocomplete or enter to send below shouldn't have any modifier keys pressed.
            if (event.metaKey || event.altKey || event.shiftKey) {
                return;
            }
            if (_this.model.autoComplete) {
                var autoComplete = _this.model.autoComplete;
                switch (event.key) {
                    case "Enter":
                        autoComplete.onEnter(event);break;
                    case "ArrowUp":
                        autoComplete.onUpArrow(event);break;
                    case "ArrowDown":
                        autoComplete.onDownArrow(event);break;
                    case "Tab":
                        autoComplete.onTab(event);break;
                    case "Escape":
                        autoComplete.onEscape(event);break;
                    default:
                        return; // don't preventDefault on anything else
                }
                event.preventDefault();
            } else if (event.key === "Enter") {
                _this._sendEdit();
                event.preventDefault();
            } else if (event.key === "Escape") {
                _this._cancelEdit();
            }
        };

        _this._cancelEdit = function () {
            _dispatcher2.default.dispatch({ action: "edit_event", event: null });
        };

        _this._sendEdit = function () {
            var newContent = {
                "msgtype": "m.text",
                "body": (0, _serialize.textSerialize)(_this.model)
            };
            var contentBody = {
                msgtype: newContent.msgtype,
                body: ' * ' + newContent.body
            };
            if ((0, _serialize.requiresHtml)(_this.model)) {
                newContent.format = "org.matrix.custom.html";
                newContent.formatted_body = (0, _serialize.htmlSerialize)(_this.model);
                contentBody.format = newContent.format;
                contentBody.formatted_body = ' * ' + newContent.formatted_body;
            }
            var content = (0, _assign2.default)({
                "m.new_content": newContent,
                "m.relates_to": {
                    "rel_type": "m.replace",
                    "event_id": _this.props.event.getId()
                }
            }, contentBody);

            var roomId = _this.props.event.getRoomId();
            _this.context.matrixClient.sendMessage(roomId, content);

            _dispatcher2.default.dispatch({ action: "edit_event", event: null });
        };

        _this._onAutoCompleteConfirm = function (completion) {
            _this.model.autoComplete.onComponentConfirm(completion);
        };

        _this._onAutoCompleteSelectionChange = function (completion) {
            _this.model.autoComplete.onComponentSelectionChange(completion);
        };

        var room = _this.context.matrixClient.getRoom(_this.props.event.getRoomId());
        var partCreator = new _parts.PartCreator(function () {
            return _this._autocompleteRef;
        }, function (query) {
            return _this.setState({ query: query });
        }, room);
        _this.model = new _model2.default((0, _deserialize.parseEvent)(_this.props.event, room), partCreator, _this._updateEditorState);
        _this.state = {
            autoComplete: null,
            room: room
        };
        _this._editorRef = null;
        _this._autocompleteRef = null;
        return _this;
    }

    (0, _createClass3.default)(MessageEditor, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this._updateEditorState();
            (0, _caret.setCaretPosition)(this._editorRef, this.model, this.model.getPositionAtEnd());
            this._editorRef.focus();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var autoComplete = void 0;
            if (this.state.autoComplete) {
                var query = this.state.query;
                var queryLen = query.length;
                autoComplete = _react2.default.createElement(
                    'div',
                    { className: 'mx_MessageEditor_AutoCompleteWrapper' },
                    _react2.default.createElement(_Autocomplete2.default, {
                        ref: function ref(_ref) {
                            return _this2._autocompleteRef = _ref;
                        },
                        query: query,
                        onConfirm: this._onAutoCompleteConfirm,
                        onSelectionChange: this._onAutoCompleteSelectionChange,
                        selection: { beginning: true, end: queryLen, start: queryLen },
                        room: this.state.room
                    })
                );
            }
            var AccessibleButton = _index2.default.getComponent('elements.AccessibleButton');
            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)("mx_MessageEditor", this.props.className) },
                autoComplete,
                _react2.default.createElement('div', {
                    className: 'mx_MessageEditor_editor',
                    contentEditable: 'true',
                    tabIndex: '1',
                    onInput: this._onInput,
                    onKeyDown: this._onKeyDown,
                    ref: function ref(_ref2) {
                        return _this2._editorRef = _ref2;
                    },
                    'aria-label': (0, _languageHandler._t)("Edit message")
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'mx_MessageEditor_buttons' },
                    _react2.default.createElement(
                        AccessibleButton,
                        { kind: 'secondary', onClick: this._cancelEdit },
                        (0, _languageHandler._t)("Cancel")
                    ),
                    _react2.default.createElement(
                        AccessibleButton,
                        { kind: 'primary', onClick: this._sendEdit },
                        (0, _languageHandler._t)("Save")
                    )
                )
            );
        }
    }]);
    return MessageEditor;
}(_react2.default.Component); /*
                              Copyright 2019 New Vector Ltd
                              Copyright 2019 The Matrix.org Foundation C.I.C.
                              
                              Licensed under the Apache License, Version 2.0 (the "License");
                              you may not use this file except in compliance with the License.
                              You may obtain a copy of the License at
                              
                                  http://www.apache.org/licenses/LICENSE-2.0
                              
                              Unless required by applicable law or agreed to in writing, software
                              distributed under the License is distributed on an "AS IS" BASIS,
                              WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                              See the License for the specific language governing permissions and
                              limitations under the License.
                              */


MessageEditor.propTypes = {
    // the message event being edited
    event: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixEvent).isRequired
};
MessageEditor.contextTypes = {
    matrixClient: _propTypes2.default.instanceOf(_matrixJsSdk.MatrixClient).isRequired
};
exports.default = MessageEditor;
module.exports = exports['default'];
//# sourceMappingURL=MessageEditor.js.map